import { get } from 'lodash';
import moment from 'moment';
import 'moment/locale/fr';
import Vue from 'vue';
import VueAxios from 'vue-axios';
import VueCurrencyFilter from 'vue-currency-filter';
import VueI18n from 'vue-i18n';
import VueMoment from 'vue-moment';
import App from './App.vue';
import axios from './backend/axios';
import i18n from './i18n';
import vuetify from './plugins/vuetify';
import './registerServiceWorker';
import router from './router';
import store from './store';

Vue.use(VueMoment, {
  moment,
});

Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(VueAxios, axios);
Vue.use(VueMoment);
Vue.use(VueCurrencyFilter, {
  symbol: '€',
  thousandsSeparator: ' ',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'back',
});

Vue.axios.interceptors.response.use((response) => {
  store.commit('setAlert', { show: false });
  return response;
}, (error) => {
  if (!error.response || error.response.status === 401) {
    delete localStorage.authorization;
    if (!get(router, 'currentRoute.meta.public')) {
      router.push(`/connexion?redirect=${router.currentRoute.path}`);
    }

    if (error.message === 'Network Error') {
      store.commit('setAlert', { text: 'Le serveur est indisponible' });
    } else {
      store.commit('setAlert', { show: false });
    }
  }
  return Promise.reject(error);
});

Vue.filter('striphtml', (value) => {
  const div = document.createElement('div');
  div.innerHTML = value;
  const text = div.textContent || div.innerText || '';
  return text;
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
